import { render, staticRenderFns } from "./VuesticIconFresh.vue?vue&type=template&id=5d3f325c"
import script from "./VuesticIconFresh.vue?vue&type=script&lang=js"
export * from "./VuesticIconFresh.vue?vue&type=script&lang=js"
import style0 from "./VuesticIconFresh.vue?vue&type=style&index=0&id=5d3f325c&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d3f325c')) {
      api.createRecord('5d3f325c', component.options)
    } else {
      api.reload('5d3f325c', component.options)
    }
    module.hot.accept("./VuesticIconFresh.vue?vue&type=template&id=5d3f325c", function () {
      api.rerender('5d3f325c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-icon/VuesticIconFresh.vue"
export default component.exports